import React from "react";
import ConstructionObjectGenericSkeleton from "./ConstructionObjectGenericSkeleton";

function ConstructionObjectDetailSkeleton() {
  return (
    <>
      <ConstructionObjectGenericSkeleton />
    </>
  );
}

export default ConstructionObjectDetailSkeleton;
